import {AWSIntergationDetailsType, EditIntegrationCommonPropsType} from "../../../../types";
import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {useForm} from "../../../../../../../newShared/hooks/useForm";
import {AWS_KMS_ENDPOINT_MAPPING_NAME} from "../../../../constants";
import {UpdateIntegration} from "../../../../store/actions";
import {loadings} from "../../../../store/slice";
import {
    UseManageWorkspacesAndOrganizations
} from "../../../../../../authWorkspacesCookies/cookies/hooks/useManageWorkspacesAndOrganizations";

export const useEditAwsKms = (props: EditIntegrationCommonPropsType) => {
    const dispatch = useDispatch();
    const {workspaceId} = UseManageWorkspacesAndOrganizations();
    const {updateIntegration} = useSelector(loadings);

    // const [fileName, setFileName] = useState<String>("");
    const {form, setForm, handleChange} = useForm<AWSIntergationDetailsType>({
        applicationId: props.details.applicationId,
        workspaceId: workspaceId ?? '',
        status: '',
        integration: {
            secretAccessKey: '',
            accessKeyId: '',
        },
        identity: props.details.identity,
        hris: props.details.hris,
        endpointMappingName: AWS_KMS_ENDPOINT_MAPPING_NAME,
        detailsId: props.details.detailsId,
        //additional:
        name: props.details.name,
    });
    const handleChangeIntegration = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({...prev, integration: {...prev.integration, [e.target.name]: e.target.value}}));
    }

    const isOk = form.integration.accessKeyId.trim().length > 0 && form.integration.secretAccessKey.trim().length > 0 && form.name.trim().length > 0;

    const handleSubmit = () => {
        if(isOk){
            dispatch(UpdateIntegration({integrationDetails: form, name: form.name, detailsId: form.detailsId}));
        }
    }

    //other

    //
    const ref = React.createRef<HTMLInputElement>();
    const filePicker = () => {
        ref.current && ref.current.click();
    };

    return{
        form,
        isOk,
        ref,
        actions: {
            handleSubmit,
            // onChangeFileInput,
            handleChangeIntegration,
            handleChange,
            filePicker
        },
        // fileName,
        isLoading: updateIntegration
    }
}